<div class="connection-entity-brand-chip">
  @if (iconUrl) {
    <img [src]="iconUrl" [alt]="displayName" class="brand-icon-image" />
  } @else {
    <span class="brand-icon-fallback" aria-hidden="true">{{ initial }}</span>
  }
  <span class="brand-name">{{ displayName }}</span>
</div>
